/**
 * Страница «Проекты» (эпик US-05, раздел после «Аналитики»).
 *
 * Основной состав — новая редакция раздела (US-26): плашка шести
 * показателей, реестр проектов с раскрытием до договоров, карточка
 * проекта и виджеты «Освоение по заказчикам (АБП)» и «Крупнейшие
 * проекты». Она заменила прежнюю редакцию US-05.1 целиком (FR-1.1,
 * FR-1.4).
 *
 * Ряд чипов-подразделов временно скрыт (решение от 11.08.2026): пока
 * виден только основной раздел. Чтобы вернуть переключение —
 * раскомментировать блок ниже и восстановить setFilter/t/cn.
 * Видимость «Инвестиционных» (US-05.2) задаёт супер-админ
 * (useModulePresent, default-visible).
 */
import { useState } from 'react';

import { InvestmentProjectsSection } from './components/InvestmentProjectsSection';
import { ProjectsSection } from './components/ProjectsSection';
import { MODULES } from '../../consts/modules';
import { useModulePresent } from '../../hooks/useModulePresent';

export type ProjectsFilter = 'infrastructure' | 'investment';

export const ProjectsPage = () => {
  const [filter] = useState<ProjectsFilter>('infrastructure');

  const showInvestment = useModulePresent(MODULES.projects.investment);

  return (
    <div className="space-y-4 p-5">
      {/* <div
        className="flex items-center gap-2.5 overflow-x-auto pb-1"
        data-testid="projects-filters"
      >
        {filters.map((key) => (
          <button
            key={key}
            type="button"
            aria-pressed={filter === key}
            onClick={() => setFilter(key)}
            data-testid={`projects-filter-${key}`}
            className={cn(
              'shrink-0 whitespace-nowrap rounded-xl px-2 py-1.5 text-sm font-medium transition-colors',
              filter === key
                ? 'bg-text text-text-inverted'
                : 'bg-surface-muted text-text hover:bg-surface-border',
            )}
          >
            {t(`projects.subtabs.${key}`)}
          </button>
        ))}
      </div> */}

      {filter === 'infrastructure' && <ProjectsSection />}
      {filter === 'investment' && showInvestment && (
        <InvestmentProjectsSection />
      )}
    </div>
  );
};
